import {
  ADD_ADMIN_REQUEST,
  UPDATE_ADMIN_REQUEST,
  DELETE_ADMIN_REQUEST,
  GET_ADMIN_REQUEST,
  GET_REMAINING_ADMIN_REQUEST,
} from "../type";
import { InsertDataWithImage } from "../../Hooks/InsertData";
import { GetDataToken } from "../../Hooks/getAllData";
import { InsUpdateData } from "../../Hooks/UpdataData";
import DeleteData from "../../Hooks/DeleteData";

export function buildAdminRequestQuery(params = {}) {
  const searchParams = new URLSearchParams();
  const normalized = {
    From: params.from ?? params.From,
    To: params.to ?? params.To,
    Request: params.request ?? params.Request,
    EmployeeId: params.employeeId ?? params.EmployeeId,
    SearchTerm: params.searchTerm ?? params.SearchTerm,
    PageNumber: params.pageNumber ?? params.PageNumber,
    PageSize: params.pageSize ?? params.PageSize,
  };

  Object.entries(normalized).forEach(([key, value]) => {
    const text = String(value ?? "").trim();
    if (!text || text === "null" || text === "undefined") return;
    searchParams.append(key, text);
  });

  return searchParams.toString();
}

export const CreateAdminRequestAction = (data) => async (dispatch) => {
  try {
    const respons = await InsertDataWithImage(
      `/api/AdministrativeRequest`,
      data
    );
    dispatch({
      type: ADD_ADMIN_REQUEST,
      payload: respons,
      loading: true,
    });
  } catch (e) {
    dispatch({
      type: ADD_ADMIN_REQUEST,
      payload: "Error" + e,
    });
  }
};
export const GetAllAdminRequestAction = (quary) => async (dispatch) => {
  try {
    const queryString =
      typeof quary === "string"
        ? buildAdminRequestQuery(Object.fromEntries(new URLSearchParams(quary)))
        : buildAdminRequestQuery(quary);
    const url = queryString
      ? `/api/AdministrativeRequest?${queryString}`
      : `/api/AdministrativeRequest`;
    const respons = await GetDataToken(url);
    dispatch({
      type: GET_ADMIN_REQUEST,
      payload: respons,
      loading: true,
    });
  } catch (e) {
    dispatch({
      type: GET_ADMIN_REQUEST,
      payload: "Error" + e,
    });
  }
};
export const GetRemainingAdminRequestAction = (quary) => async (dispatch) => {
  try {
    const respons = await GetDataToken(
      `/api/AdministrativeRequest/GetRemainingForSelectedType?${quary}`
    );
    dispatch({
      type: GET_REMAINING_ADMIN_REQUEST,
      payload: respons,
      loading: true,
    });
  } catch (e) {
    dispatch({
      type: GET_REMAINING_ADMIN_REQUEST,
      payload: "Error" + e,
    });
  }
};
export const UpdateAdminRequestAction = (body) => async (dispatch) => {
  try {
    const respons = await InsUpdateData(
      `/api/AdministrativeRequest/UpdateAdminRequest`,
      body
    );
    dispatch({
      type: UPDATE_ADMIN_REQUEST,
      payload: respons,
      loading: true,
    });
  } catch (e) {
    dispatch({
      type: UPDATE_ADMIN_REQUEST,
      payload: "Error" + e,
    });
  }
};

export const DeleteAdminRequestAction = (Id) => async (dispatch) => {
  try {
    const respons = await DeleteData(
      `/api/AdministrativeRequest/DeleteAdminRequest?id=${Id}`
    );
    dispatch({
      type: DELETE_ADMIN_REQUEST,
      payload: respons,
      loading: true,
    });
  } catch (e) {
    dispatch({
      type: DELETE_ADMIN_REQUEST,
      payload: "Error" + e,
    });
  }
};
